import { gql } from '@apollo/client';

export const UPDATE_SPECIAL_INSTRUCTIONS_SETTINGS = gql`
    mutation UpdateSpecialInstructionsSettings($client_id: uuid!, $special_instructions_settings: jsonb!) {
        update_clients_by_pk(
            pk_columns: { client_id: $client_id }
            _set: { special_instructions_settings: $special_instructions_settings }
        ) {
            client_id
            special_instructions_settings
        }
    }
`;
